<template>
    <span  >
        <div v-show="filterApply()" :class="classJoueur"  >
            
            <div style="float:right" v-if="!D_isJoin">
                <s-button 
                    :theme="!joueur.invite ? 'is-small is-light' : 'is-small is-info'" 
                    icon="user-edit" label=""
                    @onclick="editJoueur()"
                     :role="role"
                />
            </div>
        
            <div style="float:left" v-if="typeof(tournoi)!='undefined' && !D_isJoin && (!forme)">
               <s-button theme="is-small is-warning" icon="signature" 
                    label=""   :role="role" v-if="presinscrit"/>
            </div>
            <div style="float:left" v-if="typeof(tournoi)=='undefined'">
                <span :class="themeConnectPlayer.theme" >
                    <i :class="themeConnectPlayer.icon"></i>
                </span>
               
            </div>
            <div style="float:left" v-if="typeof(tournoi)!='undefined' && !D_isJoin && forme && !alea">
                <s-button theme="is-small is-primary" icon="users" 
                    label=""  
                    :role="role"
                    :disabled="equipeCompleted"
                    @onclick="joinTeam()"
                        v-if="meneur==null"
                />
                 
                <s-button theme="is-small is-primary" icon="plus" 
                    label=""  
                    :role="role"
                    :disabled="equipeCompleted"
                    @onclick="joinTeam()"
                    v-if="meneur!=null"
                />
            </div>
            <div style="float:left" v-if="D_numeroJoueurTournoi!=-1" v-show="!this.forme && !tournoi.clotured">
                <s-button 
                    :label="D_numeroJoueurTournoi+1" 
                    icon="" @onclick="desinscrire(joueur)"  :role="role"
                    :theme="!joueur.invite ? 'is-small is-success' : 'is-small is-info'"
                />
            </div>
            <div style="float:left" v-if="D_numeroJoueurTournoi!=-1" v-show="this.forme  && !tournoi.clotured">
                <s-button 
                    :label="D_numeroJoueurTournoi+1" 
                    icon="" 
                    :theme="isMeneur() ?  'is-small is-success' : 'is-small is-light'"
                    :disabled="true"
                />
            </div>

            <div class="pseudo" v-on:click="selectJoueur()">
                {{joueur.pseudo}} 
                <span v-show="joueur.pseudo==''">Invité</span>
            </div>
             <div class="nomprenom" v-on:click="selectJoueur()">
               {{joueur.prenom}} {{joueur.nom}} &nbsp;
            </div>
            
        </div>
       
       
       
        
    </span>
</template>
<style scoped>
    .nomprenom {
        font-size: 11px;
        font-style: italic;
        margin-left: 40px;
        width: 100px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
     .pseudo {
        padding-bottom: 3px;
        padding-top: 8px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13px;
        font-weight: bolder;
    }
    .Selected  {
        background-color: greenyellow;
    }
    .TeamPris {
         background-color: rgb(171, 215, 245);
    }
    .Preinscrit {
         background-color: #FFD75C;
         color: #294294;
    }
     .Cancelled  {
        background-color: rgb(105, 105, 105);
        color: rgb(161, 161, 161);
    }
    .itemJoueurLigne {
        padding: 2px;
        height: 55px;
        margin: 1px;
        width: 170px;
        text-align: center;
        display: inline-block;
        border: thin dashed gray;
        border-radius: 5px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        -moz-user-select: none; /* Firefox */
        -webkit-user-select: none; /* Chrome, Safari, Opéra depuis la version 15 */
        -ms-user-select: none; /* Internet explorer depuis la version 10 et Edge */
        user-select: none; /* Propriété standard */
        
    }
    .itemJoueurLigne:hover{
        cursor: pointer;
    }
</style>
<script>
import joueur_fct from '@/firebase/joueur'
export default {
    props:["joueur", "selection", "tournoi", "refresh","forme","meneur","role","joueurSearch", "filters", "filterInscrit","filterByLicencie", "equipes","owner", "alea"],
    
    data() {
        return {
          
            
        }
    },
    mounted() {
       
    },
    computed: {
        
        D_numeroJoueurTournoi: {
            get() {
                return parseInt(this.getNumeroJoueurTournoi());
            }
        },
        D_isJoin: {
            get() {
                return this.isJoin()
            }
        },
        presinscrit: {
            get() {
                if (typeof(this.tournoi)!="undefined")  {
                if (typeof(this.tournoi.preinscription)=="undefined")
                    return false;
                else {
                    return this.tournoi.preinscription.indexOf(this.joueur.id) != -1;
                }
                }
                else    
                    return false;
            }
        },
        themeConnectPlayer: {
            get() {
                var theme= {
                    icon:'',
                    theme: ''
                }
                var emailParent = false;
               if (typeof(this.joueur.emailParent)!="undefined")
                    emailParent = this.joueur.emailParent != '';
               if (this.owner == this.joueur.userId) {
                    theme.theme='icon is-normal has-text-danger';
                    theme.icon = 'fas fa-user-tie';
                }
                else if (this.joueur.admin) {
                    theme.theme='icon is-normal has-text-info';
                    theme.icon = 'fas fa-user-graduate';
                   
                }
                else if (emailParent) {
                     theme.theme='icon is-normal has-text-warning';
                    theme.icon = 'fas fa-user-check'
                }
                else if (this.joueur.userId == null) {
                    theme.theme='icon is-normal has-text-dark';
                    theme.icon = 'fas fa-user-slash'
                }    
                else {
                     theme.theme= 'icon is-normal has-text-success';
                    theme.icon = 'fas fa-user-check'
                    
                }
                return theme;
            }
        },
        
        classJoueur: {
            get() {
                if (!this.search())
                    return "itemJoueurLigne Cancelled";
                else if (this.presinscrit && !this.D_isJoin && !this.forme) {
                     return 'itemJoueurLigne Preinscrit'
                }
                else if (typeof(this.tournoi)=='undefined') { 
                    if (typeof(this.selection) != "undefined") {
                        if (this.selection.indexOf(this.joueur.id) == -1)
                            return 'itemJoueurLigne' ;
                        else
                            return 'itemJoueurLigne Selected'
                    }
                    else
                        return 'itemJoueurLigne' ;
                }
                else if(this.forme) {
                   
                    if (this.meneur!=null) {
                        
                        var indexJoueur = this.equipes.findIndex(elt=>elt.id === this.meneur.id);
                        if (indexJoueur == this.D_numeroJoueurTournoi)
                            return 'itemJoueurLigne Selected'
                        else if (this.D_isJoin)
                            return 'itemJoueurLigne TeamPris'
                        else
                            return 'itemJoueurLigne '
                    }
                    else {
                        var numeroEquipe = this.getNumeroJoueurTournoi()
                        if (numeroEquipe!=-1)
                                return 'itemJoueurLigne TeamPris'
                            else if (this.D_isJoin)
                                return 'itemJoueurLigne Selected'
                            else
                                return 'itemJoueurLigne '
                    }
                }
               
                else if (typeof(this.tournoi)!='undefined' && this.D_isJoin) 
                    return 'itemJoueurLigne Selected'
                else
                    return 'itemJoueurLigne'
            }
        },
         equipeCompleted: {
            get() {
                if (this.meneur)
                    return (this.meneur.coequipier1 != null) && (this.meneur.coequipier2 != null) 
                else    
                    return null;
                 /*
                if (this.meneur) {
                    if (this.tournoi.options.nbJoueursParEquipe == 2) {
                        return (this.meneur.coequipier1 != null) 
                    }
                    if (this.tournoi.options.nbJoueursParEquipe == 3) {
                       
                    }
                }*/
            }
        }
    },
    watch: {
        refresh(val) {
            
        }
    },
    methods: {
         
        selectJoueur() {
            
            if (this.role!='player') {
                if (typeof(this.tournoi)=='undefined') {
                    if (typeof(this.selection) != "undefined") {
                        var indexSelection = this.selection.indexOf(this.joueur.id)
                        if (indexSelection == -1)
                            this.selection.push(this.joueur.id);
                        else {
                            this.selection.splice(indexSelection, 1);
                        }
                    }
                    else
                        this.editJoueur()
                }
                    
                else {
                    this.join();
                }
            }
        },
        join() {
            
            if (this.role != 'player') {
                
                if (typeof(this.tournoi)!='undefined' && !this.D_isJoin && !this.presinscrit && !this.tournoi.clotured) {
                   
                    if (this.tournoi.options.mode!='FORME'  )
                        this.JoinPresinscrit();
                    else
                        this.joinTeam();
                }
                else if (typeof(this.tournoi)!='undefined' && !this.D_isJoin && (this.presinscrit || this.tournoi.clotured) && this.tournoi.options.mode!='FORME') {
                   
                    this.joinTournoi();
                }
                else if (typeof(this.tournoi)!='undefined' && !this.D_isJoin && this.presinscrit && this.tournoi.options.mode=='FORME') {
                  
                    if (this.D_numeroJoueurTournoi==-1)
                        this.joinTeam();
                }
                else if (this.D_isJoin)
                    if (!this.tournoi.options.mode=='FORME' && this.D_numeroJoueurTournoi==-1)
                        this.desinscrire();
                    else if (!this.forme)
                        this.desinscrire();
                    else if (this.alea && typeof(this.equipes[this.getNumeroJoueurTournoi()])=="undefined") 
                        this.desinscrire();
                    else
                        this.$emit("selectEquipe", this.equipes[this.getNumeroJoueurTournoi()])
                    
                        
            }   
           
        },
        search() {
            if (this.joueurSearch.pseudo=="")
                return true;
            else {
                if ( this.joueur.pseudo.toUpperCase().indexOf(this.joueurSearch.pseudo.toUpperCase()) == 0)
                    return true;
                else  if (this.joueur.nom.toUpperCase().indexOf(this.joueurSearch.pseudo.toUpperCase()) == 0)  
                    return  true;
                else if (this.joueur.prenom.toUpperCase().indexOf(this.joueurSearch.pseudo.toUpperCase()) == 0)
                    return true;
                else if (typeof(this.tournoi)!="undefined") {
                    if (!isNaN(this.joueurSearch.pseudo)) {
                        var numero = parseInt(this.joueurSearch.pseudo) - 1;
                        return this.getNumeroJoueurTournoi() == numero;
                    }
                }      
            }   
        }   
        ,
        filterApply() {
            var searchReturn = true;

            
            var tournoiInprogress = false;
            if (typeof(this.tournoi)!="undefined") {
                tournoiInprogress = this.tournoi.state == 'INPROGRESS'
            }
            
            if (tournoiInprogress) {
                // On va appliquer un filtre si on est dans un tournoi en progression
                // car cela veut dire qu'on tente d'ajouter un joueur dans un concours
                // du coup il faut cacher les joueurs qui sont déjà inscrit au concours 
                searchReturn = !this.isJoin();
            }
            else {
                searchReturn = joueur_fct.object.search(this.joueur, this.filters);
                
                if (this.filterInscrit!=null && searchReturn)
                    searchReturn = this.filterInscrit ?  this.D_isJoin : !this.D_isJoin;

                if (searchReturn) {
                    if (this.filterByLicencie != null)
                        searchReturn = this.filterByLicencie == this.joueur.isLicencie;
                }

                if (searchReturn) {
                    searchReturn = this.search();
                }
                else
                    searchReturn = false;
            }
           
            return searchReturn;
        },
        getNumeroJoueurTournoi() {
            
            if (typeof(this.tournoi) == "undefined")
                return -1;
            else {
                
                if (this.forme) {
                   
                    var indexJoueur = this.equipes.findIndex(elt=>elt.id === this.joueur.id);
                
                    if (indexJoueur == -1)
                        indexJoueur = this.equipes.findIndex(elt=>elt.coequipier1 === this.joueur.id);
                    if (indexJoueur == -1)
                        indexJoueur = this.equipes.findIndex(elt=>elt.coequipier2 === this.joueur.id);
                    
                }
                else {
                    var indexJoueur = this.tournoi.joueurs.findIndex(elt=>elt.id===this.joueur.id);
                }
                
                
                return indexJoueur;
            }
        },
        isJoin() {
           
            if (typeof(this.tournoi) != "undefined") {
                if (this.tournoi.joueurs.findIndex(elt=>elt.id===this.joueur.id) == -1)
                    return false;
                else    
                    return true;
            }
            else
                return false;
        },
        joinTeam() {
            var demo = this.$store.getters.getDemo;
            if (demo.active) {
                if (this.meneur == null)
                    demo.nbEquipes++;
                else
                    this.$store.dispatch("setUpdateDemo", demo);
            }
            this.$emit("joinTeam", this.joueur);
        },
        desinscrire() {
            this.$emit("desinscrire", this.joueur)
        },
        JoinPresinscrit() {
            this.$emit("preinscription", this.joueur);
        },
        joinTournoi() {
            this.$emit("joinTournoi", this.joueur)
            
        },
        editJoueur() {
            this.$emit("editJoueur", this.joueur)
        },
        setMeneur() {
            this.$emit("setMeneur", this.joueur)
        },
        isMeneur() {
            if (this.meneur == null)
                return false;
            else 
                return (this.D_numeroJoueurTournoi == this.joueur.id);
        }
    }
}
</script>